import { useState, type ReactElement } from "react";
import { isBloomDev } from "../lib/debug";
import { QuestionStepCards } from "./question-step/QuestionStepCards";
import { QuestionStepFaces } from "./question-step/QuestionStepFaces";
import { QuestionStepScenario } from "./question-step/QuestionStepScenario";
import { QuestionStepSlider } from "./question-step/QuestionStepSlider";
import { QuestionStepSpectrum } from "./question-step/QuestionStepSpectrum";
import { QuestionVariantPicker } from "./question-step/QuestionVariantPicker";
import type { QuestionStepProps, QuestionUiVariant } from "./question-step/types";

const VARIANT_COMPONENTS: Record<
  QuestionUiVariant,
  (props: QuestionStepProps) => ReactElement
> = {
  slider: QuestionStepSlider,
  cards: QuestionStepCards,
  spectrum: QuestionStepSpectrum,
  faces: QuestionStepFaces,
};

export function QuestionStep(props: QuestionStepProps) {
  const [variant, setVariant] = useState<QuestionUiVariant>("slider");

  if (props.question.kind === "scenario") {
    return <QuestionStepScenario {...props} />;
  }

  const VariantView = VARIANT_COMPONENTS[variant];

  return (
    <div className="bloom-question-wrap">
      {isBloomDev() ? <QuestionVariantPicker value={variant} onChange={setVariant} /> : null}
      <VariantView {...props} />
    </div>
  );
}
